<img
    src="assets/images/agreem_logo.svg"
    alt="logo"
    class="logo-expanded"
    routerLink="/dashboard"
    style="cursor: pointer"
/>
<div>
    <app-contact-us />
    <app-topbar-dropdown />
</div>
